import { SecurityQuestionModel } from "../../components/renderers/v2/SecurityQuestionRendered";
import { Translatable } from "../Translatable";

let defaultLanguage = "en";
export function setDefaultLanguage(language) {
    defaultLanguage = language;
}

export function translate(
    translatable: Translatable,
    key: string,
    language: string,
    defaultText?: string,
): string {
    if (translatable == null || translatable.translatedTexts == null) {
        return null;
    }
    const translatedText = translatable.translatedTexts[key.toLowerCase()];
    if (!translatedText) {
        return defaultText || "";
    }
    return translatedText[language] || defaultText || translatedText[defaultLanguage] || "";
}

export function translatedSecurityQuestionsList(
    translatable: { translatedTexts: { [key: string]: SecurityQuestionModel[] } },
    language: string
): SecurityQuestionModel[] {
    if (translatable == null || translatable.translatedTexts == null) {
        return null;
    }
    const translatedText = translatable.translatedTexts;
    if (!translatedText) {
        return [];
    }
    return translatedText[language] || translatedText[defaultLanguage] || [];
}